import { AppId, createEntityManagementRoutes } from '@lumapps/router';

const emailDomainRouteSlug = 'domains-management/email-domains';

export const emailDomainRoutes = createEntityManagementRoutes({
    appId: AppId.backOffice,
    slug: emailDomainRouteSlug,
});
